<script setup>
import { ref } from 'vue'
import Icon from './Icon.vue'
import { store } from '@/store/appStore.js'
const logoFailed = ref(false)
</script>

<template>
  <nav class="nav-rail">
    <div class="brand">
      <img :src="'/hetero-logo.png'" alt="Hetero" class="brand-logo" v-show="!logoFailed" @error="logoFailed=true" />
      <div class="brand-mark" v-show="logoFailed">PF</div>
      <div class="brand-text">
        <strong>Pharmacy First</strong>
        <span>Hetero Labs Ltd.</span>
      </div>
    </div>
    <div class="role-tag">
      <span>{{ store.currentRole.value?.label }}</span>
      <button @click="store.backToRoleSelect()" title="Switch role"><Icon name="logout" :size="13" /></button>
    </div>
    <div class="nav-list">
      <div class="nav-section-label">Modules</div>
      <a v-for="m in store.visibleModules.value" :key="m.id"
         class="nav-item" :class="{ active: store.state.activeModule === m.id }"
         @click="store.setActiveModule(m.id)">
        <Icon :name="m.icon" :size="16" />
        <span>{{ m.label }}</span>
      </a>
    </div>
  </nav>
</template>
